import { Label } from "@packages/ds";
import styled, { css } from "styled-components";

import * as Table from "ds/Table";

import { EnvironmentListBar as EnvironmentListBarUnstyled } from "../";

import type { Filter } from "./List";

export const Wrapper = styled.div``;

export const EnvLabel = styled(Label)`
  margin-bottom: 0px;
`;

export const EnvironmentListBar = styled(EnvironmentListBarUnstyled)`
  width: auto;
  height: 56px;
  line-height: 56px;
  margin: 0 32px;
  border-top: 1px solid var(--mode-border-neutral-weakest);

  &:first-child {
    border: 0;
  }

  @media (max-width: 768px) {
    margin: 0 16px;
  }
`;

export const TableThead = styled(Table.Thead)`
  padding: 0 32px 8px;
  border-bottom: 1px solid var(--mode-border-neutral-weakest);
  display: none;
  @media (min-width: 1025px) {
    display: flex;
  }
`;

export const TableTh = styled(Table.Th)<{ kind: Filter }>`
  width: 100px;
  margin-right: 40px;

  ${({ kind }) =>
    kind === "title" &&
    css`
      width: auto;
      margin-right: auto;
    `}

  ${({ kind }) =>
    kind === "deployed_at" &&
    css`
      margin-left: 16px;
    `}
`;
